var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M437.02,437.02c-99.974,99.974-262.065,99.974-362.04,0s-99.974-262.065,0-362.04 c7.87,7.869,204.631,157.408,204.631,157.408L437.02,437.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M74.981,74.981c99.974-99.974,262.065-99.974,362.04,0s99.974,262.065,0,362.04"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDA44"
    },
    cx: 256,
    cy: 256,
    r: 66.783
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "95.325,367.305 102.35,381.994 118.213,378.327 111.109,392.978 123.867,403.095  107.983,406.674 108.027,422.957 95.325,412.77 82.623,422.957 82.667,406.674 66.783,403.095 79.541,392.978 72.436,378.327  88.3,381.994  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "49.372,244.87 56.397,259.559 72.26,255.891 65.157,270.543 77.913,280.66 62.03,284.239  62.074,300.522 49.372,290.336 36.671,300.522 36.714,284.239 20.831,280.66 33.588,270.543 26.484,255.891 42.347,259.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "95.325,144.696 102.35,159.385 118.213,155.717 111.11,170.369 123.867,180.486  107.983,184.065 108.027,200.348 95.325,190.162 82.623,200.348 82.667,184.065 66.784,180.486 79.54,170.369 72.436,155.717  88.3,159.385  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "152.408,222.609 159.433,237.298 175.297,233.63 168.192,248.283 180.949,258.399  165.066,261.979 165.109,278.261 152.408,268.075 139.706,278.261 139.75,261.979 123.867,258.399 136.623,248.283 129.52,233.63  145.383,237.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "111.591,289.392 117.117,306.398 134.997,306.398 120.531,316.908 126.057,333.913  111.591,323.404 97.125,333.913 102.651,316.908 88.185,306.398 106.065,306.398  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DA544"
    },
    d: "M256,300.522h22.261c0,0,9.646-17.065,0-33.391l22.261-22.261l-11.13-22.261h-11.13 c0,0-5.565,16.696-27.826,16.696c-22.261,0-27.826-16.696-27.826-16.696h-11.13l11.13,22.261l-11.13,22.261l11.13,11.13 c0,0,11.13-22.261,33.391-11.13C256,267.131,265.461,281.044,256,300.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M422.153,140.223c0.525-2.735,0.804-5.556,0.804-8.444c0-19.8-12.928-36.571-30.8-42.357 c5.461,11.1,8.539,23.584,8.539,36.792c0,4.454-0.358,8.824-1.031,13.089c-2.69-4.333-6.145-8.292-10.366-11.651 c-15.901-12.652-37.63-12.987-53.695-2.332c12.403,2.708,24.395,8.213,35.002,16.652c8.304,6.608,15.014,15.546,20.152,24.174 l-67.975,21.285c66.783,11.13,122.435-33.391,122.435-33.391C439.051,141.708,429.475,139.628,422.153,140.223z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.386b4b4cf67162ba0ae7eb93af0394c5.svg";
export { ForwardRef as ReactComponent };